import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { initialBookingForm, initialShipmentForm } from "../actions/formAction";


const initialShipmentState = {
    loading: 'idle',
    hasError: false,
    errorMessage: '',
    data: {
        
    }
};

const formInitialShipmentSlice = createSlice({
    name: "initialShipmentData",
    initialState: initialShipmentState,
    reducers: {
        resetState: (state) => {
            state.loading = 'idle';
            state.hasError = false;
            state.errorMessage = '';
            state.data = {
            
            };
        }
    },
    extraReducers: (builder) => {
        builder

        .addCase(PURGE, () => {
            return initialShipmentState;
        })
            .addCase(initialShipmentForm.pending, (state) => {
                state.loading = 'pending';
                state.hasError = false
                state.errorMessage = '';

            })
            .addCase(initialShipmentForm.fulfilled, (state, action) => {
                const response = action.payload;
                state.loading = 'succeeded';
                state.data = response;
                state.hasError = false;
                state.errorMessage = '';

            })
            .addCase(initialShipmentForm.rejected, (state, action) => {
                state.loading = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload;
            });
    }
});

export const { resetState } = formInitialShipmentSlice.actions;

export default formInitialShipmentSlice.reducer;
